import { useEffect, useState } from "react";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { postBroadcastGroupData } from "@services/API/Requests/BroadcastGroupRequests";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TranslateErrorMessage } from "@services/ErrorHandling";
import { error_message } from "@constants/Errors";
import { YOBELY_PATHS } from "@constants/NavigationPaths";
import { useSelector } from "react-redux";
import { BROADCASTGROUP } from "@types/broadcastGroup";
import { BlankBroadcastGroupData } from "@templates/BlankBroadcastGroupData";

export const UseCreateYobelyGroupPage = () => {
  const navigate: NavigateFunction = useNavigate();
  const { parentId } = useParams<{ parentId: string }>();

  const masterString = "Master";
  const tempUserId = useSelector((state) => state.userForm.tempUserId);

  const isNotMaster: string | null =
    parentId && parentId !== masterString ? parentId : null;

  const [broadcastGroup, setBroadcastGroup] = useState<BROADCASTGROUP | null>(
    BlankBroadcastGroupData,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const errorToast = (response) => toast.error(`${response}`);
  const successToast = (response) => toast.success(`${response}`);

  const [warningModalOpen, setWarningModalOpen] = useState<boolean>(false);

  const [errors, setErrors] = useState({
    name: false,
    name_kana: false,
  });

  useEffect(() => {
    setBroadcastGroup(BlankBroadcastGroupData);
  }, []);

  const handleInputChange = (key: string, value: string) => {
    setBroadcastGroup((prevState) =>
      prevState ? { ...prevState, [key]: value } : prevState,
    );
  };

  const verifyFields = () => {
    return !Object.values(errors).some((error) => error === true);
  };

  const updateError = (field, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: value,
    }));
  };

  const handleSave = async (event) => {
    setError("");
    setLoading(true);
    event.preventDefault();
    const fields = verifyFields();

    if (!fields) {
      errorToast(error_message.generic.bad_field);
      return;
    }

    if (broadcastGroup) {
      if (isNotMaster) {
        broadcastGroup.parent = parentId;
      }
      let response;
      await postBroadcastGroupData(
        setBroadcastGroup,
        broadcastGroup,
        setLoading,
        setError,
      )
        .then((response) => {
          if (response.status == 200) {
            successToast(response.message);
            setTimeout(() => {
              if (tempUserId) {
                navigate("/users/" + tempUserId);
              } else {
                navigate(YOBELY_PATHS.main);
              }
            }, 1000);
          } else {
            const errorMessage = TranslateErrorMessage(response.message);
            console.error(errorMessage);
            setError(errorMessage);
            errorToast(errorMessage);
          }
        })
        .catch((error) => {
          const errorMessage = TranslateErrorMessage(error.message);
          console.error(errorMessage);
          setError(errorMessage);
          errorToast(errorMessage);
        });
    }
  };

  const onCancel = () => {
    if (tempUserId) {
      navigate("/users/" + tempUserId);
    } else {
      navigate(YOBELY_PATHS.main);
    }
  };

  const handleOpenWarningModal = () => {
    setWarningModalOpen(true);
  };

  const handleCloseWarningModal = () => {
    setWarningModalOpen(false);
  };

  return {
    loading,
    isNotMaster,
    error,
    errors,
    broadcastGroup,
    warningModalOpen,
    handleInputChange,
    handleOpenWarningModal,
    handleSave,
    updateError,
    handleCloseWarningModal,
    onCancel,
  };
};
